var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnSmallWallet = function SvgIcnSmallWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 10.08c.497 0 .9-.405.9-.905s-.403-.905-.9-.905-.9.406-.9.905c0 .5.403.905.9.905Z",
    fill: "#6E7079"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.584 2.211c.053.217.064.457.064.69v.887h-1.2V2.9a.302.302 0 0 0-.375-.305c-.046.01-.096.023-.15.037L4.462 4.145c-.253.096-.45.185-.603.266.174-.04.355-.061.541-.061h7.2c1.325 0 2.4 1.08 2.4 2.413v4.825a2.406 2.406 0 0 1-2.4 2.413H4.4C3.075 14 2 12.92 2 11.588V5.543c0-.553.063-1.007.42-1.489.345-.464.903-.767 1.644-1.048a.598.598 0 0 1 .052-.017l5.498-1.521c.29-.077.56-.13.803-.134.244-.004.52.04.759.219.242.182.354.435.408.658ZM3.204 6.66l-.004.68v4.249c0 .666.537 1.206 1.2 1.206h7.2c.663 0 1.2-.54 1.2-1.206V6.763c0-.667-.537-1.207-1.2-1.207H4.4c-.628 0-1.144.485-1.196 1.103Z",
    fill: "#6E7079"
  })));
};
export default SvgIcnSmallWallet;